import { IAnalyticsEventPage, IAnalyticsEventPageArgument } from './types';

export const PAGE_VIEWED_EVENT = 'Page Viewed';

export const pageViewed = (
  page: IAnalyticsEventPageArgument,
): IAnalyticsEventPage => {
  return {
    eventName: PAGE_VIEWED_EVENT,
    object_name: page.name,
    object_id: page.id,
    object_type: page.category,
  };
};
